// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"01252e4d","486":"12e49703","560":"ac06f62c","569":"25da7f1f","696":"4b9bfce8","887":"a019bc07","966":"a64e2182","984":"f71c435e"}[chunkId] + ".chunk.js";
};